module.exports = __webpack_public_path__ + "static/media/introduction-recibase_02.eb554e17.jpg";